import React from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import Loading from './Loading';
import Error from './Error';
import AdminAdventure from './AdminAdventure';
import AdminCreateAdventureModal from './AdminCreateAdventureModal';
import {apiBaseUrl} from './Config';

class AdminAdventureGrid extends React.Component {
    constructor(props) {
	super(props);
	this.state = {
	    error: null,
	    isLoaded: false,
	    adventures: [],
	    showCreateAdventure: false
	};

	this.resource = apiBaseUrl + "adventures?type=" + props.type;

	this.handleSuccess = this.handleSuccess.bind(this);
	this.handleError = this.handleError.bind(this);
    }

    componentDidMount() {
	this.fetchAdventures();
    }

    handleSuccess() {
	this.setState({
	    showCreateAdventure: false
	});

	this.fetchAdventures();

	this.props.onSuccess();
    }
    
    handleError() {
	this.setState({
	    showCreateAdventure: false
	});

	this.props.onError();
    }

    fetchAdventures() {
	fetch(this.resource, {
	    headers: {
		"Authorization": "Bearer " + this.props.token,
		"Accept": "application/json"
	    }
	})
	    .then(response => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}
		
		return response.json()
	    })
	    .then((result) => {
		this.setState({
		    isLoaded: true,
		    adventures: result
		});
	    })
	    .catch((error) => {
		this.setState({
		    isLoaded: true,
		    error
		});
	    })
    }
    
    render() {
	const { error, isLoaded, adventures } = this.state;
	
	if (error) {
	    return (
		<Error error={error} />
	    );
	} else if (!isLoaded) {
	    return (
		<Loading />
	    );
	} else {
	    return (
		<>
		<br />
		    <div className="right">
			<OverlayTrigger overlay={<Tooltip>L&auml;gg till &auml;ventyr</Tooltip>}>
			    <img src="file_add.png" alt="L&auml;gg till" className="pointer" onClick={() => this.setState({showCreateAdventure: true})} />
			</OverlayTrigger>
		    </div>

		    <br />
		    
		    <div className="content">
			{adventures.map(adventure => (
			    <AdminAdventure adventure={adventure}
					    key={adventure.id}
					    token={this.props.token}
					    onSuccess={this.handleSuccess}
					    onError={this.handleError}
					    onAuthError={this.props.onAuthError}
			    />
			))}
			
			<AdminCreateAdventureModal show={this.state.showCreateAdventure}
						   token={this.props.token}
						   type={this.props.type}
						   onHide={() => this.setState({showCreateAdventure: false})}
						   onSuccess={this.handleSuccess}
						   onError={this.handleError}
						   onAuthError={this.props.onAuthError}
			/>
		    </div>
		</>
	    );
	}
    }
}

export default AdminAdventureGrid;
